import React, { useContext } from 'react';

import { Table, Form, Input } from 'semantic-ui-react';

import _toInteger from 'lodash/toInteger';

import { InventoryContext } from 'components/core/MenuForm/Menu.context';
import { areAdditionalServiceAttributesSupported } from 'components/core/menu/libs/menu-helpers';

import PriceField from '../../../fields/PriceField/PriceField';

export default function MenuItemVariant({
  index,
  name: variationName,
  price: variationPrice,
  duration: variationDuration,
  shortDescription: variationShortDescription,
  isMoney,
  onUpdate: onUpdateProp,
  onDelete: onDeleteProp,
}) {
  const { activePatch } = useContext(InventoryContext);
  const hasRecipeSupport = areAdditionalServiceAttributesSupported(activePatch);

  function onChange({ target: { name, value } }) {
    onUpdateProp(index, name, value);
  }

  function onChangeDuration({ target: { name, value } }) {
    const finalValue = _toInteger(value) || null;
    onUpdateProp(index, name, finalValue);
  }

  function onDelete() {
    onDeleteProp(index);
  }

  return (
    <Table.Row>
      <Table.Cell>
        <Form>
          <Form.Group>
            <Form.Input
              width={10}
              fluid
              label="Name"
              required
              placeholder="Variant Name"
              defaultValue={variationName}
              name="name"
              onChange={onChange}
            />
            <PriceField
              width={6}
              label={isMoney ? 'Price' : 'Label'}
              placeholder="1.99"
              priceInitialValue={variationPrice}
              name="price"
              onChange={onChange}
              isMoney={isMoney}
            />
          </Form.Group>
          {hasRecipeSupport && (
            <Form.Group>
              <Form.Field width={10}>
                <label htmlFor="short_description">Short Description</label>
                <Input
                  value={variationShortDescription}
                  onChange={onChange}
                  name="shortDescription"
                />
                <small className="helper">
                  You can use basic markdown as <b>**bold**</b>, <i>*italic*</i> or
                  [link](https://example.com) for a named link.
                </small>
              </Form.Field>
              <Form.Input
                width={6}
                type="number"
                step="1"
                label="Service Duration (in minutes)"
                name="duration"
                value={variationDuration}
                onChange={onChangeDuration}
              />
            </Form.Group>
          )}
        </Form>
      </Table.Cell>
      <Table.Cell>
        {index > 0 && (
          // TODO implement the following rule
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a href="#" onClick={onDelete}>
            Delete
          </a>
        )}
      </Table.Cell>
    </Table.Row>
  );
}
